// ----------------------------------------------------------------------

const account = {
  displayName: sessionStorage.getItem("name") ? sessionStorage.getItem("name") : 'TSE Name',
  email: localStorage.getItem("user_email") ? localStorage.getItem("user_email") : 'tse@abtasty.com',
  photoURL: localStorage.getItem("user_trello_photo")  + '/50.png' ? localStorage.getItem("user_trello_photo") + '/50.png' : '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
